import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	resetFirstLastMargins,
	resetButton,
	linkUnderline,
} from '@/css/resources/placeholders.css';
import {
	fluidPadding,
	fluidValues,
	fontStyle,
	fluidBorderRadius,
	fluidBorderWidth,
} from '@/css/resources/mixins.css';
import { zIndex } from '@/css/resources/variables.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidValues('width', styles?.width?.[0], styles?.width?.[1]),
		fluidValues(
			'right',
			styles?.position?.right?.[0],
			styles?.position?.right?.[1]
		),
		fluidValues(
			'bottom',
			styles?.position?.bottom?.[0],
			styles?.position?.bottom?.[1]
		),
		fluidPadding(styles?.padding),
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,
			overflow: 'hidden',

			'.supt-gdprBanner__title': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),

			'.supt-gdprBanner__message': fontStyle({
				...styles?.text?.typography,
				textAlign: styles?.text?.textAlignment,
				color: styles?.text?.color,
			}),

			'.supt-gdprBanner__rejectButton': fontStyle({
				...styles?.link?.typography,
				textAlign: styles?.link?.textAlignment,
				color: styles?.link?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(
		{
			position: 'fixed',
			zIndex: zIndex.gdprBanner,
			maxWidth: '100%',

			'.supt-gdprBanner__title, .supt-gdprBanner__message':
				resetFirstLastMargins,

			'.supt-gdprBanner__rejectButton': cssObj(
				resetButton,
				linkUnderline,
				resetFirstLastMargins,
				{
					backgroundPosition: '0 calc(1em)',
				}
			),

			'.supt-gdprBanner__buttons': {
				display: 'flex',
				justifyContent: 'flex-start',
				alignItems: 'center',
				marginTop: 10,
				button: {
					cursor: 'pointer',
					'&:last-child': {
						marginRight: 0,
						marginLeft: 5,
					},
				},
			},

			/**
			 * STATES
			 */
			'&[aria-hidden="true"]': {
				display: 'none',
			},
		},
		getDynamicStyles(styles)
	);

export { getStyles };
